// Constructores de mensajes para las notificaciones de cobranza (WhatsApp y correo).
// Centralizan el formato de monto y el saludo dinámico según la hora de CDMX,
// evitando duplicar textos entre la tabla de Cobranza y el modal de envío.

import { getDynamicGreeting } from '@/lib/dates';

const currencyFormatter = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  minimumFractionDigits: 0,
  maximumFractionDigits: 6,
});

// Monto formateado en pesos mexicanos (mismo criterio que la mesa de Cobranza).
export function formatMXN(val: number): string {
  return currencyFormatter.format(Number(val) || 0);
}

// Mensaje exacto que se envía por WhatsApp. No incluye variables de mora.
// "Hola, {saludo}. Su factura por un monto de {total} correspondiente a sus
//  servicios ha sido enviada por correo electrónico. Quedamos a sus órdenes, saludos."
export function buildWhatsAppInvoiceMessage(total: number): string {
  const saludo = getDynamicGreeting();
  const monto = formatMXN(total);
  return `Hola, ${saludo}. Su factura por un monto de ${monto} correspondiente a sus servicios ha sido enviada por correo electrónico. Quedamos a sus órdenes, saludos.`;
}

// Asunto por defecto del correo de envío de factura.
export function buildInvoiceEmailSubject(): string {
  return 'Envío de factura WIALON';
}

// Cuerpo por defecto del correo:
// "Muy {saludo}, estimado {nombre_cliente}, le enviamos su factura por un monto
//  de {total} correspondiente a sus servicios."
export function buildInvoiceEmailMessage(clientName: string, total: number): string {
  const saludo = getDynamicGreeting();
  const monto = formatMXN(total);
  return `Muy ${saludo}, estimado ${clientName}, le enviamos su factura por un monto de ${monto} correspondiente a sus servicios.`;
}

// Divide una cadena de correos (separados por coma, punto y coma o espacio) en
// una lista limpia y única de direcciones.
export function parseEmailList(raw: string | null | undefined): string[] {
  if (!raw) return [];
  const seen = new Set<string>();
  const result: string[] = [];
  raw.split(/[,;\s]+/).forEach((part) => {
    const email = part.trim();
    if (email && !seen.has(email.toLowerCase())) {
      seen.add(email.toLowerCase());
      result.push(email);
    }
  });
  return result;
}

// Valida de forma ligera que una cadena tenga forma de correo electrónico.
export function isLikelyEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}